// extracted by mini-css-extract-plugin
export var active = "_c1-7";
export var blink = "_c1-8";
export var dropDownSelector = "_c1-4";
export var dropDownWrapper = "_c1-3";
export var fakeCursor = "_c1-6";
export var fontSizeButton = "_c1-9";
export var formQuillEditor = "_c1-0";
export var pressed = "_c1-a";
export var qlBlank = "_c1-1";
export var textFormattingToolbar = "_c1-2";
export var textToolbarOption = "_c1-5";